import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { initRedditPixel } from "../utils/redditPixel";
import { initGoogleAnalytics } from "../utils/googleAnalytics";
import "./ConsentBanner.scss";

export default function ConsentBanner() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const consent = localStorage.getItem("consent.analytics");
    if (!consent) {
      // Show banner after a brief delay so it doesn't flash on quick visits
      const timer = setTimeout(() => setVisible(true), 800);
      return () => clearTimeout(timer);
    }
    if (consent === "granted") {
      initRedditPixel();
      initGoogleAnalytics();
    }
  }, []);

  function acceptAll() {
    localStorage.setItem("consent.analytics", "granted");
    localStorage.setItem("consent.timestamp", new Date().toISOString());
    initRedditPixel();
    initGoogleAnalytics();
    setVisible(false);
  }

  function rejectAll() {
    localStorage.setItem("consent.analytics", "denied");
    localStorage.setItem("consent.timestamp", new Date().toISOString());
    setVisible(false);
  }

  if (!visible) return null;

  return (
    <div
      className="consent-banner"
      role="dialog"
      aria-live="polite"
      aria-label="Cookie consent"
    >
      <div className="consent-banner__content">
        <div className="consent-banner__text">
          <h3>Your Privacy Matters</h3>
          <p>
            We use cookies and similar technologies to improve your experience,
            analyze site traffic, and deliver personalized content. By clicking
            "Accept All," you consent to our use of cookies for analytics and
            advertising purposes.
          </p>
          <p className="consent-banner__policy-link">
            Learn more in our <Link to="/privacy-policy/">Privacy Policy</Link>.
          </p>
        </div>
        <div className="consent-banner__actions">
          <button
            className="consent-banner__btn consent-banner__btn--accept"
            onClick={acceptAll}
            aria-label="Accept all cookies"
          >
            Accept All
          </button>
          <button
            className="consent-banner__btn consent-banner__btn--decline"
            onClick={rejectAll}
            aria-label="Reject all cookies"
          >
            Reject All
          </button>
        </div>
      </div>
    </div>
  );
}
